import { render, staticRenderFns } from "./PrintCertificateButton.vue?vue&type=template&id=74eff56b&scoped=true"
import script from "./PrintCertificateButton.vue?vue&type=script&lang=js"
export * from "./PrintCertificateButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74eff56b",
  null
  
)

export default component.exports